module.exports = __webpack_public_path__ + "img/1.45c2e13e.jpg";